import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { API_URL } from "../../../config";
import axiosInstance from "../../../utils/axiosInstance";
import "./AddJobs.css";

function AddJobs() {
  const navigate = useNavigate();

  const [departments, setDepartments] = useState([]);
  const [services, setServices] = useState([]);
  const [errors, setErrors] = useState({ opend_Date: "", close_date: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    department: "",
    service: "",
    designation: "",
    no_of_Opening: "",
    mini_salary: "",
    max_salary: "",
    skills: "",
    job_des: "",
    job_type: "",
    opend_Date: "",
    close_date: "",
  });

  useEffect(() => {
    axios
      .get(`${API_URL}/api/getDepartment`)
      .then((res) => setDepartments(res.data))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (!formData.department) return;
    axios
      .get(`${API_URL}/api/getServicebyDepartment/${formData.department}`)
      .then((res) => setServices(res.data))
      .catch((err) => console.log(err));
  }, [formData.department]);

  const validateDates = (name, value) => {
    const openDate = new Date(name === "opend_Date" ? value : formData.opend_Date);
    const closeDate = new Date(name === "close_date" ? value : formData.close_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let newErrors = { ...errors };

    if (name === "opend_Date" && openDate < today) {
      newErrors.opend_Date = "Opening date cannot be in the past.";
    } else {
      newErrors.opend_Date = "";
    }

    if (formData.opend_Date && closeDate < openDate) {
      newErrors.close_date = "Closing date cannot be earlier than opening date.";
    } else {
      newErrors.close_date = "";
    }

    setErrors(newErrors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "opend_Date" || name === "close_date") {
      validateDates(name, value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (!formData.department || !formData.service) {
      alert("Please select both Department and Service.");
      return;
    }

    if (errors.opend_Date || errors.close_date) {
      alert("Please fix date validation errors first.");
      return;
    }

    try {
      setIsSubmitting(true);
      await axiosInstance.post(`${API_URL}/api/addJob`, formData);
      alert("Job added successfully.");
      navigate("/admin/jobopening");
    } catch (error) {
      alert(error?.response?.data?.message || "Failed to submit form.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-job-page">
      <div className="add-job-shell">
        <div className="add-job-hero">
          <p className="add-job-eyebrow">Recruitment CRM</p>
        <h2>Add New Job Vacancy</h2>
        <p>Fill details to create a new job opportunity</p>
      </div>

      <div className="add-job-card">
        <form onSubmit={handleSubmit}>
          <h5 className="add-job-section-title">Basic Info</h5>

          <div className="add-job-grid add-job-grid-basic">
            <select className="add-job-input" name="department" value={formData.department} onChange={handleChange}>
              <option value="">Select Department</option>
              {departments.map((d) => (
                <option key={d._id} value={d._id}>
                  {d.deptName}
                </option>
              ))}
            </select>

            <div>
              <select className="add-job-input" name="service" value={formData.service} onChange={handleChange}>
                <option value="">Select Service</option>
                {services.map((s) => (
                  <option key={s._id} value={s._id}>
                    {s.serviceName}
                  </option>
                ))}
              </select>

              <Link
                to="/admin/addService"
                className="add-job-link"
              >
                + Add Service
              </Link>
            </div>

            <input className="add-job-input" type="number" placeholder="Openings" name="no_of_Opening" value={formData.no_of_Opening} onChange={handleChange} />
            <input className="add-job-input" type="text" placeholder="Designation" name="designation" value={formData.designation} onChange={handleChange} />
            <input className="add-job-input" type="number" placeholder="Min Salary" name="mini_salary" value={formData.mini_salary} onChange={handleChange} />
            <input className="add-job-input" type="number" placeholder="Max Salary" name="max_salary" value={formData.max_salary} onChange={handleChange} />
          </div>

          <h5 className="add-job-section-title add-job-section-gap">Job Details</h5>
          <input className="add-job-input add-job-gap-sm" type="text" placeholder="Skills" name="skills" value={formData.skills} onChange={handleChange} />
          <textarea className="add-job-input add-job-textarea add-job-gap-md" rows="4" placeholder="Job Description" name="job_des" value={formData.job_des} onChange={handleChange} />

          <h5 className="add-job-section-title">Schedule</h5>
          <div className="add-job-grid add-job-grid-schedule">
            <select className="add-job-input" name="job_type" value={formData.job_type} onChange={handleChange}>
              <option value="">Select Job Type</option>
              <option>Full Time</option>
              <option>Part Time</option>
              <option>Work from Home</option>
              <option>Work from Office</option>
            </select>

            <input
              className="add-job-input"
              type="date"
              name="opend_Date"
              value={formData.opend_Date}
              onChange={handleChange}
            />

            <input
              className="add-job-input"
              type="date"
              name="close_date"
              value={formData.close_date}
              min={formData.opend_Date || new Date().toISOString().split("T")[0]}
              onChange={handleChange}
            />
          </div>

          {errors.opend_Date && <p className="text-danger">{errors.opend_Date}</p>}
          {errors.close_date && <p className="text-danger">{errors.close_date}</p>}

          <button type="submit" disabled={isSubmitting} className="add-job-submit">
            {isSubmitting ? "Submitting..." : "+ Add Job"}
          </button>
        </form>
      </div>
      </div>
    </div>
  );
}

export default AddJobs;
